import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Headline = styled.h6`
  ${Typography.body_lg}
  color: var(--text-secondary);
  margin: 0;
`;

const Icon1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  :hover {
    background-color: var(--neutral-secondary);
    border-radius: 4px;
  }
  ${mobile_xl(css`
    padding: 3px;
  `)}
`;

const Input = styled.input`
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  padding: 8px 12px;
  min-width: calc(100% - 20px);
  :focus-visible {
    outline: none;
  }
`;

const InputDiv = styled.div`
  position: relative;
  .icon {
    position: absolute;
    right: 12px;
    top: 45%;
    transform: translateY(-50%);
  }
`;

const ButtonSection = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 12px;
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const UserName = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: 0;
  text-align: left !important;
`;

const UserRole = styled.span`
  ${Typography.body_xs};
  color: var(--text-secondary);
  margin: 0;
`;
export { Headline, Icon1, Input, InputDiv, ButtonSection, UserDetails, UserName, UserRole };
